export { default } from "./AfterSalesIndicator";
